<template>
  <div class="alert" :class="level">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'PAlert',
  props: {
    level: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped lang="scss">
.alert {
  color: var(--color-black);
  background-color: var(--color-white);
  border-radius: 0;
  border: 1px solid var(--color-inactive-light);
  position: relative;
  padding: 1.2rem 2rem;
  margin-bottom: 1.6rem;

  &::before {
    content: '';
    height: 100%;
    width: 6px;
    position: absolute;
    left: 0;
    top: 0;
  }

  &.error::before {
    background-color: var(--color-error);
  }

  &.warning::before {
    background-color: var(--color-warning);
  }

  &.success::before {
    background-color: var(--color-success);
  }

  &.info::before {
    background-color: var(--color-main);
  }
}
</style>
